import { CoordinatorService } from './coordinator.service';

export type TABLE_FROM_MAP_ARGS = string[] | 'all' | 'not-empty';

class ScriptText {
    #coords: CoordinatorService;
    #data: string;

    constructor(
        coords: CoordinatorService,
        public parent: ScriptHtml | ScriptElement,
        data: string,
    ) {
        this.#coords = coords;
        this.#data = data;
    }

    get body() {
        return this.#coords.utils$.escapeHTML(this.#data);
    }
}

class ScriptAction {
    #coords: CoordinatorService;
    #label: string;
    #action: string;

    constructor(
        coords: CoordinatorService,
        public parent: ScriptElement,
        label: string,
        action: string,
    ) {
        this.#coords = coords;
        this.#label = label;
        this.#action = action;
    }

    get body() {
        return `<button onclick="window.postMessage(
            {type: 'scriptAction', 
             action: \`${this.#action}\`}, 
            '${window.location.origin}');">${this.#label}</button>`;
    }
}

class ScriptAttribute {
    #coords: CoordinatorService;
    #name: string;
    #value: string;

    constructor(
        coords: CoordinatorService,
        public parent: ScriptElement,
        name: string,
        value: string,
    ) {
        this.#coords = coords;
        this.#name = name;
        this.#value = value;
    }

    get body() {
        const v = this.#coords.utils$.escapeHTML(this.#value, true);
        return `${this.#name}="${v}"`;
    }
}

class ScriptElement {
    #coords: CoordinatorService;
    #tag: string;

    #childLs: (ScriptElement | ScriptText | ScriptAction)[] = [];
    #attLs: ScriptAttribute[] = [];

    constructor(
        coords: CoordinatorService,
        public parent: ScriptHtml | ScriptElement,
        tag: string,
    ) {
        this.#coords = coords;
        this.#tag = tag;
    }

    get body(): string {
        const attrs = this.#attLs.map((x) => x.body).join(' ');
        const inner = this.#childLs.map((x) => x.body).join('');
        return `<${this.#tag} ${attrs}>${inner}</${this.#tag}>`;
    }

    addText(txt: string) {
        this.#childLs.push(new ScriptText(this.#coords, this, txt));
        return this;
    }

    addAction(label: string, action: string) {
        const act = new ScriptAction(this.#coords, this, label, action);
        this.#childLs.push(act);
        return act;
    }

    addAttribute(name: string, val: string) {
        const att = new ScriptAttribute(this.#coords, this, name, val);
        this.#attLs.push(att);
        return att;
    }

    addChildElement(tag: string) {
        const el = new ScriptElement(this.#coords, this, tag);
        this.#childLs.push(el);
        return el;
    }
}

export class ScriptHtml {
    #coords: CoordinatorService;

    #flowLs: (ScriptElement | ScriptText)[] = [];

    constructor(coords: CoordinatorService) {
        this.#coords = coords;
    }

    addText(txt: string) {
        this.#flowLs.push(new ScriptText(this.#coords, this, txt));
    }

    addElement(tag: string) {
        const el = new ScriptElement(this.#coords, this, tag);
        this.#flowLs.push(el);
        return el;
    }

    get body() {
        return this.#flowLs.map((x) => x.body).join('');
    }

    tableFromMap(arg: TABLE_FROM_MAP_ARGS, mp: Map<string, any>) {
        console.log('TABLE FROM MAP', arg, mp);
        const table = new ScriptElement(this.#coords, this, 'table');

        const isNotEmpty = arg === 'not-empty';
        if (!Array.isArray(arg)) {
            arg = [] as string[];
            mp.forEach((v, k) => {
                if (isNotEmpty && (v === undefined || v === '')) return;
                (arg as string[]).push(k);
            });
        }

        arg.forEach((k) => {
            const tr = table.addChildElement('tr');
            tr.addChildElement('th').addText(k);
            tr.addChildElement('td').addText(mp.get(k) || '');
        });

        return table;
    }
}
